import { type Theme } from '@mui/material';

export const resolveColor = (theme: Theme, color: string) => {
    const [variant, token = 'main'] = color.split('.');

    return (theme.palette[variant]?.[token] || theme.fixed[variant]?.[token]) ?? color;
};
